import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import { ensureNamespaceLoaded } from "../../i18n/lazyNamespaces";
import Chat from "../Chat";
import WorkspaceShell from "../Team/components/WorkspaceShell";
import { POPUP_TEAM_BASE } from "../../utils/teamNavigation";

const TeamChatPopup = () => {
  useEffect(() => {
    void ensureNamespaceLoaded("chat");
    void ensureNamespaceLoaded("team");
    void ensureNamespaceLoaded("teamTasks");
    void ensureNamespaceLoaded("teamAgenda");
  }, []);

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        bgcolor: "background.default",
      }}
    >
      <WorkspaceShell activeSection="service" basePath={POPUP_TEAM_BASE}>
        <Routes>
          <Route index element={<Chat />} />
          <Route path=":id" element={<Chat />} />
        </Routes>
      </WorkspaceShell>
    </Box>
  );
};

export default TeamChatPopup;
